import { Routes, Route } from "react-router-dom";

//Pages
import LoginPage from "../../pages/Login";
import RegisterPage from "../../pages/Register";
import NotFoundPage from "../../pages/NotFound/NotFound";
import EmployeeLoginPage from "../../pages/EmployeeLogin";
import LogoutPage from "../../pages/Logout";
import ForgotPasswordPage from "../../pages/Login/ForgotPassword";
import ResetPasswordPage from "../../pages/Login/ResetPassword";
import VerifyEmailPage from "../../pages/Login/VerifyEmail";
import LandingPage from "../../pages/LandingPage";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18next from "i18next";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import UserAgreement from "../../pages/agreementPages/UserAgreement";
import TermsOfUse from "../../pages/agreementPages/TermsOfUse";
import PrivacyAgreement from "../../pages/agreementPages/PrivacyAgreement";
import MembershipServiceAgreement from "../../pages/agreementPages/MembershipServiceAgreement";
import PersonalMarketingConsent from "../../pages/agreementPages/PersonalMarketingConsent";
import RemoteHealthInfo from "../../pages/agreementPages/RemoteHealthInfo";
import RemoteHealthDistanceSales from "../../pages/agreementPages/RemoteHealthDistanceSales";
import UserMembershipAydinlatmaMetni from "../../pages/agreementPages/UserMembershipAydinlatmaMetni";
import KvkkPolicy from "../../pages/agreementPages/KvkkPolicy";
import KvkkRemoteHealthInfo from "../../pages/agreementPages/KvkkRemoteHealthInfo";
import RemoteHealthServiceTermsInfo from "../../pages/agreementPages/RemoteHealthServiceTermsInfo";
import Sozlesmeler from "../../pages/agreementPages/Sozlesmeler";

const OtherRoutes = () => {
  return (
    <LocalizationProvider
      adapterLocale={i18next.language}
      dateAdapter={AdapterDayjs}
    >
      <ToastContainer position="top-center" newestOnTop closeOnClick pauseOnHover style={{ zIndex: 10000 }} />
      <Routes>
        {/* Ana sayfa - Landing Page (hem / hem /home) */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/superlogin" element={<LoginPage superLogin />} />
        <Route path="/a/login" element={<EmployeeLoginPage />} />
        <Route path="/register/:userType" element={<RegisterPage />} />
        {/* <Route path="/doctor-register" element={<DoctorRegister />} /> */}
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/employee/forgot-password" element={<ForgotPasswordPage variant="employee" />} />
        <Route path="/assistant/forgot-password" element={<ForgotPasswordPage variant="assistant" />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/employee/reset-password" element={<ResetPasswordPage variant="employee" />} />
        <Route path="/assistant/reset-password" element={<ResetPasswordPage variant="assistant" />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/user-agreement" element={<UserAgreement />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyAgreement />} />
        <Route path="/gizlilik-politikasi" element={<PrivacyAgreement />} />
        <Route path="/kullanim-kosullari" element={<TermsOfUse />} />
        <Route path="/uyelik-sozlesmesi" element={<UserAgreement />} />
        <Route path="/uyelik-ve-hizmet-sozlesmesi" element={<MembershipServiceAgreement />} />
        <Route path="/kisisel-pazarlama-acik-riza-metni" element={<PersonalMarketingConsent />} />
        <Route path="/uzaktan-saglik-bilgilendirme" element={<RemoteHealthInfo />} />
        <Route path="/kvkk-uzaktan-saglik-bilgilendirme" element={<KvkkRemoteHealthInfo />} />
        <Route path="/uzaktan-saglik-sunumu-bilgilendirme" element={<RemoteHealthServiceTermsInfo />} />
        <Route path="/sozlesmeler" element={<Sozlesmeler />} />
        <Route path="/uzaktan-saglik-mesafeli-satis-sozlesmesi" element={<RemoteHealthDistanceSales />} />
        <Route path="/kullanicilar-aydinlatma-metni" element={<UserMembershipAydinlatmaMetni />} />
        <Route path="/kvkk-politikasi" element={<KvkkPolicy />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </LocalizationProvider>
  );
};

export default OtherRoutes;
